import { useEffect, useCallback } from 'react';
import { useSection } from '../../useSection';
import { SectionBuilder } from '../../components/SectionBuilder';

export default function Hpc({ onRegisterSave, onRegisterDirty, onBack }) {
  const { data: headerData, setField: setHeaderField, saveSection: saveHeaderSection, isDirty: headerIsDirty } =
    useSection('product:hpc', 'domain-header', 0);
  const { data: footerData, setField: setFooterField, saveSection: saveFooterSection, isDirty: footerIsDirty } =
    useSection('product:hpc', 'domain-footer', 1);

  const save = useCallback(async () => {
    await saveHeaderSection();
    await saveFooterSection();
  }, [saveHeaderSection, saveFooterSection]);

  useEffect(() => {
    if (onRegisterSave) onRegisterSave(save);
    return () => { if (onRegisterSave) onRegisterSave(null); };
  }, [save, onRegisterSave]);

  const isDirty = useCallback(() => headerIsDirty() || footerIsDirty(), [headerIsDirty, footerIsDirty]);
  useEffect(() => {
    if (onRegisterDirty) onRegisterDirty(isDirty);
    return () => { if (onRegisterDirty) onRegisterDirty(null); };
  }, [isDirty, onRegisterDirty]);

  return (
    <div className="rp-admin-wrap">
      <h2 className="rp-admin-title">슈퍼컴퓨팅시스템</h2>

      <div style={{ marginBottom: 28, paddingBottom: 28, borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>도메인 헤더</span>
          <span style={{ fontSize: 12, color: '#888' }}>제품 목록 위에 표시 (소개, 응용 분야 등)</span>
        </div>
        <SectionBuilder value={headerData.content || ''} onChange={(v) => setHeaderField('content', v)} />
      </div>

      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>제품 목록</span>
          <span style={{ fontSize: 12, color: '#888' }}>스펙 카드 섹션으로 제품을 구성하세요</span>
        </div>
        <SectionBuilder value={footerData.content || ''} onChange={(v) => setFooterField('content', v)} />
      </div>

      {onBack && (
        <div style={{ marginTop: '1.5rem' }}>
          <button type="button" className="btn-secondary" onClick={onBack}>← 응용 분야로 돌아가기</button>
        </div>
      )}
    </div>
  );
}
